import { EventFormType, EventInitialValues } from "@pages/EventManagement/Data";
import { FilterElementType } from "@utils/DynamicComponentUtils";
import {
  exposureStatusCheck,
  textFormat,
  upDataAtFormat,
} from "@utils/TableItemFormattingUtils";
import { ColDef } from "ag-grid-community";
import { CommonFilterDataType } from "src/types/common";

export interface NoticeInitialValues extends EventInitialValues {}

export interface NoticeFormType extends EventFormType {}

export const noticeData: CommonFilterDataType<
  NoticeInitialValues,
  NoticeFormType,
  ColDef
> = {
  formInitialValues: {
    title: "",
    isExposed: "",
    startDate: "",
    endDate: "",
  },
  forms: [
    {
      type: FilterElementType.INPUT,
      name: "title",
      label: "제목",
    },
    {
      type: FilterElementType.SELECT,
      name: "isExposed",
      label: "노출 상태",
      option: [
        {
          label: "전체",
          value: "",
        },
        {
          label: "노출",
          value: true,
        },
        {
          label: "미노출",
          value: false,
        },
      ],
    },
    {
      type: FilterElementType.DATE_RANGE_PICKER,
      name: "startDate",
      secondName: "endDate",
      label: "게시 기간",
    },
  ],
  tableList: [
    {
      field: "id",
      headerName: "게시물ID",
      maxWidth: 120,
      minWidth: 100,
      flex: 1,
      suppressMovable: true,
      cellRenderer: textFormat,
    },
    {
      field: "isExposed",
      headerName: "노출 상태",
      maxWidth: 120,
      flex: 1,
      suppressMovable: true,
      cellRenderer: exposureStatusCheck,
    },
    {
      field: "postDataAt",
      headerName: "게시 기간",
      minWidth: 200,
      maxWidth: 360,
      flex: 1,
      suppressMovable: true,
      cellRenderer: textFormat,
    },
    {
      field: "title",
      headerName: "제목",
      width: 750,
      flex: 1,
      suppressMovable: true,
      cellRenderer: textFormat,
    },

    {
      field: "updatedAt",
      headerName: "업데이트 일시",
      minWidth: 180,
      maxWidth: 200,
      flex: 1,
      suppressMovable: true,
      cellRenderer: upDataAtFormat,
    },
    {
      field: "manager",
      headerName: "마지막 수정",
      pinned: "right",
      suppressMovable: true,
      maxWidth: 180,
      cellRenderer: textFormat,
    },
  ],
};
